// extracted by mini-css-extract-plugin
export default {"label__toggle_theme":"styles_label__toggle_theme__EghrV"};